// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { convertDMStoDD } from 'helpers/coordsConversion'
import { valueAsMeters } from 'helpers/unitConversion'

// compares initial and submitted site values for a single segment end
// to determine if a trigger field has been modified and shout trigger
// Callsign Cascade 2.
// This checks to see if these fields were modified:
// siteName
// contactId
// latitude
// longitude
// groundElevation

const compareSiteValues = (initialSiteValues, submitSiteValues) => {
  const oldTriggeredValues = {}

  if (initialSiteValues.siteName !== submitSiteValues.siteName) {
    oldTriggeredValues.siteName = initialSiteValues.siteName
  }

  if (initialSiteValues.contactId !== submitSiteValues.contactId) {
    oldTriggeredValues.contactId = initialSiteValues.contactId
  }

  // Compares the initial DMS value to the submit DMS value
  // then stores the initial value as DD
  if (initialSiteValues.latitude !== submitSiteValues.latitude) {
    oldTriggeredValues.latitude = convertDMStoDD(initialSiteValues.latitude)
  }

  // Compares the initial DMS value to the submit DMS value
  // then stores the initial value as DD
  if (initialSiteValues.longitude !== submitSiteValues.longitude) {
    oldTriggeredValues.longitude = convertDMStoDD(initialSiteValues.longitude)
  }

  // Compares the two values as meters. Although there is a possibility of a slight drift here,
  // (if original value was initially not entered through this UI)
  // (since original value is in M and we might be comparing against values which were converted to ft)
  // it is negligible and understood that this will not be a great enough change to be an issue for this workflow.
  if (valueAsMeters(initialSiteValues.elevation, initialSiteValues.elevationUnit) !== valueAsMeters(submitSiteValues.elevation, submitSiteValues.elevationUnit)) {
    oldTriggeredValues.elevation = valueAsMeters(initialSiteValues.elevation, initialSiteValues.elevationUnit)
  }

  return oldTriggeredValues
}

export default compareSiteValues
